import { Link } from 'react-router-dom';
import { usePortalSetting } from '@/hooks/usePortalSetting';

export default function PlatformIntro() {
  // 官网配置接口，失败时降级为 mock 数据
  const { introHighlights, platformIntro } = usePortalSetting();

  return (
    <section id="intro" className="scroll-mt-24 w-full px-4 md:px-8 py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">
          <div className="relative">
            <div className="w-full h-[340px] md:h-[440px] rounded-lg overflow-hidden">
              <img
                src={platformIntro.image}
                alt="中西医结合智慧生态平台"
                title="中西医结合智慧生态平台 - 数智化与中西医协同"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="absolute -bottom-6 right-4 md:-right-6 bg-background-50 rounded-lg border border-background-200 px-6 py-5 w-[210px]">
              <div className="flex items-center gap-2 text-primary-600 mb-2">
                {platformIntro.positionIcon && (
                  <i className={`${platformIntro.positionIcon} text-xl`}></i>
                )}
                <span className="text-sm font-medium">{platformIntro.positionLabel}</span>
              </div>
              <p className="font-heading font-bold text-foreground-900 leading-snug whitespace-pre-line">
                {platformIntro.positionText}
              </p>
            </div>
          </div>

          <div>
            <div className="flex items-center gap-2 mb-3">
              <span className="w-6 h-px bg-primary-500"></span>
              <span className="text-sm font-medium tracking-wide text-primary-600">平台介绍</span>
            </div>
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 leading-snug text-balance mb-5">
              {platformIntro.title}
            </h2>
            <div className="space-y-4 text-sm md:text-base text-foreground-800 leading-relaxed">
              {platformIntro.paragraphs.map((paragraph, index) => (
                <p key={index} className="whitespace-pre-line">
                  {paragraph}
                </p>
              ))}
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5 mt-14 md:mt-20">
          {introHighlights.map((item) => (
            <div
              key={item.id}
              className="group flex gap-4 p-5 md:p-6 rounded-lg bg-background-50 border border-background-200 hover:border-accent-300 transition-colors"
            >
              <span className="shrink-0 w-12 h-12 flex items-center justify-center rounded-md bg-accent-100 text-accent-700 group-hover:bg-accent-500 group-hover:text-background-50 transition-colors">
                <i className={`${item.icon} text-xl`}></i>
              </span>
              <div>
                <h3 className="font-heading font-semibold text-foreground-900 mb-1.5">{item.title}</h3>
                <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-10 text-center">
          <Link
            to="/about"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-md border border-primary-300 text-primary-600 text-sm font-medium hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer whitespace-nowrap"
          >
            了解更多平台理念
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}